import React from 'react';
import {
  Button, Modal, DateCalendar, Tooltip,
} from '@routific/hive';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';

interface MoveDateModalProps {
  visible: boolean;
  selectedDate: DateTime | undefined;
  isSubmitting: boolean;
  routeCount: number;
  disableSubmit?: boolean;
  onSelectDate: (date: DateTime | null) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

const MoveDateModal: React.FC<MoveDateModalProps> = ({
  visible,
  selectedDate,
  isSubmitting,
  routeCount,
  disableSubmit,
  onSelectDate,
  onSubmit,
  onCancel,
}) => {
  const { t } = useTranslation(['components', 'common']);

  const okText = isSubmitting
    ? t('moveRoutes.moving', { count: routeCount })
    : t('moveRoutes.move', { count: routeCount });

  const okButton = (
    <Button
      type="primary"
      onClick={onSubmit}
      loading={isSubmitting}
      disabled={disableSubmit}
    >
      {okText}
    </Button>
  );

  return (
    <Modal
      size="small"
      centered
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
      title={t('moveRoutes.title', { count: routeCount })}
      footer={(
        <>
          <Button onClick={onCancel} disabled={isSubmitting}>
            {t('common:cancel')}
          </Button>
          <Tooltip
            title={disableSubmit
              ? t('moveRoutes.sameDayDisabledTooltip', { count: routeCount })
              : undefined}
            disabled={disableSubmit}
          >
            {okButton}
          </Tooltip>
        </>
      )}
    >
      <DateCalendar
        fullscreen
        value={selectedDate ?? null}
        onChange={onSelectDate}
      />
    </Modal>
  );
};

export default MoveDateModal;
